export default __webpack_public_path__ + "static/media/89t.cbb70e1e.jpg";